<template>
  <InfoRichiestaRimborsi />
</template>

<script>
import InfoRichiestaRimborsi from '../components/pratiche/InfoRichiestaRimborsi.vue'

export default {
  components: {
    InfoRichiestaRimborsi,
  },

  mounted() {
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value,
    })
  },
}
</script>
